module.exports = __webpack_public_path__ + "8f801776d5249c56119f132c0be5f333.png";